var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container-fluid overview"},[_c('div',{staticClass:"header pt-4 pb-4 pl-3 pr-4"},[_vm._t("list")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }